<template>
<div>
<ContentHeader v-if="item"  :title="inputfield_name"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="AuditActionPlan" ></ContentHeader>


<div class="content_card" >
<div class="grid">

<div class="col-12">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">

<div class="grid">
<div class="col-12 md:col-8">
<CustomAuditInputfield :data="item.inputfield"></CustomAuditInputfield>

<hr/>

<h4 class="text-primary">Denetim Bulgusu</h4>
<div v-html="item.inputfield.submissions[0].submission_note" style="white-space: pre-line;" class="text-info">

</div>

</div>


<div class="col-12 md:col-4" v-if="userrole=='supplier'">
<ActionPlanPanel :nonconformity="item" @nonconformityDataUpdated="nonconformityDataUpdated"></ActionPlanPanel>
</div>

<div class="col-12 md:col-4" v-if="userrole=='admin' || userrole=='brand'">
<ActionPlanAdminPanel :nonconformity="item" @nonconformityDataUpdated="nonconformityDataUpdated"></ActionPlanAdminPanel>
</div>

</div>	
</div>

</div>
</div>
</div>


</div>	
</template>

<script>
export default {

  name: 'AuditActionPlanItem',
  props:["nonconformity"],

  data () {
    return {
    	item:null,
    	loading:true,
    	flowsupplier:null,
    	projectsupplier:null,
    }
  },
  computed:{
    userrole()
    {
      let roles = this.$store.state.auth.user.userroles
      roles = roles.map((item)=>{return item.name})
      if(roles.includes("supplier"))
      {
        return "supplier"
      }
      if(roles.includes("admin"))
      {
        return "admin"
      }
      if(roles.includes("auditor"))
      {
        return "auditor"
      }
      if(roles.includes("brand"))
      {
        return "brand"
      }
      return null
    },
  	inputfield_name()
  	{
      console.log("inputfield_name")
      console.log(this.item)
  		if(this.item)
  		{
        if(this.item.inputfield.translations.length)
        {
          let translation = this.item.inputfield.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
          {
            if(translation)
            {
              console.log("has trans")
              return translation.translation
            }
            else
            {
              console.log("has no trans")
              return this.item.inputfield.name
            }
          }
        }
        else
        {

        }
  			return this.item.inputfield.name
  		}
  		return null
  	},
  	headerurlparams()
  	{
  		if(this.projectsupplier && this.flowsupplier)
  		{
  			return {project_id:this.projectsupplier.uuid,flow_id:this.flowsupplier.uuid}
  		}
  		return null
  	}
  },
  mounted()
  {
    console.log(this.$store.state.auth.user)
  	this.getData()
  },
  methods:{
  	prepareNonconformity(nonconformity)
    {
      let obj = nonconformity.inputfield
      obj.completion = true
      obj.show_evidence_btn = false
      obj.show_info_textarea = false
      obj.read_only_state = true
      obj.options = nonconformity.inputfield.questionlist.options
      
      nonconformity.inputfield = obj
      nonconformity.inputfield_name = nonconformity.inputfield.name
      console.log()

      return nonconformity
    },
  	async getData()
  	{
  		this.loading = true
  		let data = await this.generalApiGetWithoutLoader("audit/get_nonconformity_data/"+this.$route.params.nonconformity_id)
  		this.item = await this.prepareNonconformity(data.nonconformity)
  		this.flowsupplier = await data.flowsupplier
  		this.projectsupplier = await data.projectsupplier
  		//await this.$store.dispatch('evaluation/setMode',"viewing")
      	//await this.$store.dispatch('evaluation/setEvaluation',data.flowsupplier) 
  		console.log(data)
  		this.loading = false
  	},
  	nonconformityDataUpdated(data)
  	{  		     
      	this.item = this.prepareNonconformity(data)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>